module.exports = __webpack_public_path__ + "img/e-learning-header.4abfd979.jpg";